module.exports = __webpack_public_path__ + "img/japan-stomach-cancer-male.1c5897c2.png";